class BottomNaviModule {
  constructor() {
    this.bottomNavi = document.querySelector('.js-bottomNavi');
    if (!this.bottomNavi) return;

    this.footer = document.querySelector('#footer');
    this.topHideY = 200;

    this.init();
  }

  setBottomVisible(visible) {
    this.bottomNavi.classList.toggle('is-bottom-visible', visible);
  }

  shouldHideByFooter() {
    if (!this.footer) return false;
    const viewportBottom = window.scrollY + window.innerHeight;
    return viewportBottom >= this.footer.offsetTop;
  }

  update() {
    this.setBottomVisible(window.scrollY > this.topHideY && !this.shouldHideByFooter());
  }

  init() {
    this.update();
    window.addEventListener('scroll', () => this.update(), { passive: true });
    window.addEventListener('resize', () => this.update());
  }
}

export default BottomNaviModule;
